import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { Args } from 'webapp/components/metric-library/grid-item-base';
import ScriptsGridItem from 'webapp/components/scripts/grid-item';

import type { CustomQuery } from 'webapp/models-custom';

export default class CustomQueryGridItem<T extends Args> extends ScriptsGridItem<T> {
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;

	override trackingEvent = TrackingEvent.NEW_QUERY;
	override trackingEventForCreated = TrackingEvent.QUERY_CREATED;

	override get trackingWizardType() {
		const customMetricModel = this.model.rootModel as CustomQuery | null;

		if (customMetricModel) {
			return customMetricModel.trackingWizardType;
		}

		return null;
	}
}
